import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

/**
 * main.jsx — точка входа.
 * Монтирует виджет в #root (dev/demo).
 *
 * Для WordPress: собери командой `npm run build`,
 * подключи dist/assets/*.js и *.css через functions.php,
 * добавь <div id="ibc-root"></div> в шаблон.
 */
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);
